import {createSlice} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {fetchAllStages} from '../../app/thunk'

export const stageSlice = createSlice({
    name: 'stages',
    initialState: {},
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchAllStages.fulfilled,
            (state: RootState, action) => {
                state.allstages = action.payload
            }
        )
    },
})

export default stageSlice.reducer
